import { useQuery, type QueryClient } from '@tanstack/react-query';
import { platformCan, type PlatformMeResponse, type PlatformPerm } from '@bifeai/shared';
import { api } from './api';

export const ME_KEY = ['me'] as const;
const fetchMe = () => api.get<PlatformMeResponse>('/platform/auth/me');

export function useMeQuery() {
  return useQuery({ queryKey: ME_KEY, queryFn: fetchMe, retry: false, staleTime: 60_000 });
}

/** Trae la sesión actualizada antes de navegar después de un paso de acceso. */
export async function reloadMe(qc: QueryClient): Promise<PlatformMeResponse | null> {
  try {
    return await qc.fetchQuery({ queryKey: ME_KEY, queryFn: fetchMe, staleTime: 0 });
  } catch {
    qc.removeQueries({ queryKey: ME_KEY });
    return null;
  }
}

/** Permisos de la persona según su rol (la API los vuelve a verificar siempre). */
export function useCan(): (perm: PlatformPerm) => boolean {
  const me = useMeQuery();
  const role = me.data?.admin.role;
  return (perm) => (role ? platformCan(role, perm) : false);
}
